export default __webpack_public_path__ + "static/media/Group 1692.9608d266.png";